<template>
    <div v-if="listready" class="wrapper">
        <div class="animated fadeIn">
            <b-card header="<i class='fa fa-align-justify'></i><strong> Glastypes</strong>">
                <item-list
                        :items="items"
                        @delete-item="deleteItem">
                </item-list>
            </b-card>
        </div>

        <b-modal title="Verwijderen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Dit glastype kan niet verwijderd worden! Dit glastype wordt nog gebruikt in een afdeling. {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/glastype';
    import ItemList from './List';

    export default {
        data () {
            return {
                warningModal: false,
                listready: false,
                errormsg: '',
                items: [],
            };
        },
        created () {
            this.getItems();
        },
        methods: {
            getItems () {
                api.getListGlastype().then((response) => {
                    this.items = response.data;
                    this.listready = true;
                });
            },
            deleteItem (id) {
                api.deleteGlastype(id).then(() => {
                    this.getItems();
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-list': ItemList,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/glastype/Index.vue